import { Badge, Tooltip } from '@sgme/ui';
import UnderlyingValidationErrors from 'components/shared/underlyings/underlying-validation-errors';
import { useTranslateValidationError } from 'hooks/use-translate-validation-error';
import { QuoteFormError } from 'state/addonForm/addonForm.selector';

export function ErrorBadge({ errors }: { errors?: QuoteFormError[] }) {
  if (!errors?.length) {
    return null;
  }

  const isError = errors.some(error => error.severity === 'Error');

  return (
    <Tooltip color={isError ? 'warning' : 'info'} position="right" contents={<ErrorList errors={errors} />}>
      <Badge
        size="sm"
        isPill
        color={isError ? 'warning' : 'info'}
        aria-label={`Block has ${errors.length} field errors`}
        role="status"
      >
        {errors.length}
      </Badge>
    </Tooltip>
  );
}

function ErrorList({ errors }: { errors: QuoteFormError[] }) {
  const translateError = useTranslateValidationError();

  return (
    <ul className="text-start p-0 flex-y gap-1 py-1">
      {errors.map(error => (
        <li key={error.translationKey}>
          <div className="px-1 flex-x gap-2 align-items-center fs-6">
            <i className="icon icon-outlined icon-sm" aria-hidden="true">
              info
            </i>
            {translateError(error, 'quote.errorMessages.')}
          </div>
          {error.underlyingValidationErrors && (
            <UnderlyingValidationErrors underlyingValidationErrors={error.underlyingValidationErrors} />
          )}
        </li>
      ))}
    </ul>
  );
}
